/**
 * @generated SignedSource<<ddab8d9421413d42950671bb3697061a>>
 * @relayHash 74228a2da9c649e9992679c1ef785d7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50c90d9ba1eeba128d19c12d4524cc885c79cd85e1b33812ccfa4cdebdbe9492

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PopupContentThemeQuery$variables = {
  entityId: string;
  isThemingRelayMigrationEnabled: boolean;
};
export type PopupContentThemeQuery$data = {
  readonly jira?: {
    readonly jiraProject: {
      readonly background: {
        readonly __typename: "JiraColorBackground";
        readonly colorValue: string | null | undefined;
      } | {
        readonly __typename: "JiraGradientBackground";
        readonly gradientValue: string | null | undefined;
      } | {
        readonly __typename: "JiraMediaBackground";
        readonly customBackground: {
          readonly altText: string | null | undefined;
          readonly id: string | null | undefined;
        } | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PopupContentThemeQuery = {
  response: PopupContentThemeQuery$data;
  variables: PopupContentThemeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isThemingRelayMigrationEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "entityId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "LinkedField",
  "name": "background",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorValue"
        }
      ],
      "type": "JiraColorBackground"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "gradientValue"
        }
      ],
      "type": "JiraGradientBackground"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCustomBackground",
          "kind": "LinkedField",
          "name": "customBackground",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "name": "altText"
            }
          ]
        }
      ],
      "type": "JiraMediaBackground"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PopupContentThemeQuery",
    "selections": [
      {
        "condition": "isThemingRelayMigrationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupContentThemeQuery",
    "selections": [
      {
        "condition": "isThemingRelayMigrationEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "50c90d9ba1eeba128d19c12d4524cc885c79cd85e1b33812ccfa4cdebdbe9492",
    "metadata": {},
    "name": "PopupContentThemeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "906a26584404857660dc6ab718cd845b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
